import { AfterViewInit, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-delete-data',
  imports: [CommonModule, FormsModule],
  templateUrl: './delete-data.component.html',
  styleUrl: './delete-data.component.css'
})
export class DeleteDataComponent implements AfterViewInit {
  email = '';
  submitted = false;

  ngAfterViewInit(): void {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }

  submitRequest(): void {
    if (!this.email.trim()) {
      return;
    }

    this.submitted = true;
  }
}
